// src/utils/htmlSanitizer.js

/**
 * Remove any <link href="*.css"> or <script src="*.js"> tags.
 */
export function sanitizeHead(inner) {
  return inner
    .replace(/<link\b[^>]*href=(["'])[^\1]+?\.css\1[^>]*>/gi, '')
    .replace(/<script\b[^>]*\bsrc=(["'])[^\1]+?\.js\1[^>]*>(?:<\/script>)?/gi, '');
}

/**
 * Compose a full HTML document for the iframe.
 */
export function buildIframeDoc({ cleanHead, cssCode, bodyInner, jsCode }) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <base href="about:blank">
  ${cleanHead}
  <style>${cssCode}</style>
</head>
<body>
  ${bodyInner}
  <script>${jsCode}</script>
</body>
</html>`;
}
